/** @format */
import {useEffect} from 'react';

import {useLocation} from 'react-router-dom';

const useScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [location.hash]);
};

export {useScrollToAnchor};
